<template>
	<drawer
			title="Edit company"
			@updateClose="onDrawerClose"
			@updateSave="onSave"
	>
		<div class="top_description">
    <span class="top_description-icon">
        <svg-sprite height="20" width="20" icon-id="warn" style="color: #F49741"></svg-sprite>
    </span>
			<span>At the same time truck can’t belongs to several companies.</span>
		</div>
		<div class="groupFields">
			<div class="groupField">
				<field
						margin="0 0 10px 0"
						width="300px"
						label="Customer"
						placeholder="Select customer"
						@updateAutocomplete="onAutocomplete($event, 'customer')"
						:autocompleteValue="customer"
						:items="customers"
						:isClearable="false"
						is-autocomplete
						is-attach
				></field>
			</div>
			<div class="groupField">
				<field
						margin="0 10px 0 0"
						width="145px"
						type="text"
						label="Date from"
						placeholder="Enter date from"
						displayFormat="YYYY-MM-DD"
						format="YYYY-MM-DD"
						:dateValue="from"
						@updateTime="onDate($event, 'from')"
						:pickTime="false"
						is-time
				></field>
				<field
						margin="0"
						width="145px"
						type="text"
						label="Date to"
						placeholder="Enter date to"
						displayFormat="YYYY-MM-DD"
						format="YYYY-MM-DD"
						:dateValue="to"
						@updateTime="onDate($event, 'to')"
						:pickTime="false"
						is-time
				></field>
			</div>
		</div>
	</drawer>
</template>

<script>
import moment from "moment";
import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	name: "ChangeCompanyDrawer",
	components: { Drawer },
	props: {
		editData: Object,
		customers: Array
	},
	data: () => ({
		drawer: true,
		customer: null,
		from: null,
		to: null,
		note: '',
		id: null,
		validDate: false
	}),
	methods: {
		onAutocomplete({ value }, key) {
			this[key] = value;
		},
		onDate(date, key) {
			this[key] = date;
			this.validDate = moment(this.from).isAfter(this.to);
		},
		onDrawerClose(type) {
			if ( type == "close" || type == "cancel" ) this.onClose();
			if ( type == "outside" ) this.onClickOutside();
		},
		onClickOutside() {
			this.drawer = false;
			this.$emit('closeDrawer', 0);
		},
		onClose(mark) {
			this.drawer = false;
			this.$emit('closeDrawer', mark);
		},
		async onSave() {
			const { value, id } = this.customer;
			const values = {
				...this.editData,
				customer: value,
				customer_id: id,
				from: this.from,
				to: this.to
			};
			this.$emit('updateEditServices', values);
			this.onClose(0);
		}
	},
	mounted() {
		const { id, customer_id, customer, from, to } = this.editData;

		this.customer = { value: customer, id: customer_id };
		this.from = from;
		this.to = to;
		this.id = id;
	}
};
</script>

<style scoped lang="scss">
.groupFields {
	padding: 20px 0;
	width: 100%;

	.groupField {
		width: 100%;
		display: flex;
	}
}

.top_description {
	display: flex;
	align-items: center;
	margin: 20px 0;

	&-icon {
		min-width: 20px;
		display: inline-block;
	}

	span {
		display: inline-block;
		margin-left: 10px;
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: var(--base-orange);
	}
}
</style>
